<template lang="pug">
.b-search-form(:class="{ 'search-form--is-open': isOpen }")
    .input-group
        button._button.-close.btn.ps-4.ps-md-5(
            type="button",
            @click="emitClose"
        ) Закрыть
        input._input.form-control(
            v-model="userInput",
            @keyup.enter="emitChange",
            :tabindex="!isOpen ? -1 : 1",
            ref="input",
            placeholder="Минимум 3 символа"
        )
        button._button.-submit.btn.pe-4.pe-md-5(
            type="button",
            @click="emitChange"
        ) Искать
</template>

<script>
export default {
    name: "SearchInputComponent",
    props: {
        isOpen: { required: false, type: Boolean, default: false },
    },
    computed: {
        query: {
            get() {
                return this.$store.state.searchQuery;
            },
            set(val) {
                if(val.length < 3) return;
                this.$store.commit("setSearchQuery", val);
            },
        },
    },
    data: () => ({
        userInput: null,
    }),
    methods: {
        emitChange() {
            if (this.$router.history.current.path != "/") {
                this.$router.push("/");
            }
            this.query = this.userInput;
            this.$emit("change", this.query);
        },
        emitClose() {
            this.userInput = null;
            this.$store.commit("setSearchQuery", null);
            this.$emit("close");
        },
    },
    watch: {
        isOpen(to) {
            if (to) this.$refs.input.focus();
            if (!to) this.userInput = null;
        },
    },
};
</script>
